import { AppModal } from "./AppModal";

export const ExpiredSessionModal = ({
  isOpen,
  onOpenChange,
  isLoading = false,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}) => {
  return (
    <AppModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="Session Expired"
      description="Your session has expired. Would you like to extend your current session?"
      confirmButtonText="Extend session"
      cancelButtonText="No, thanks"
      isLoading={isLoading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
